import alertSettings from '../ducks/alertSettings/reducers';
import alertSettingsV3 from '../ducks/alertSettingsV3/reducers';
import alerts from '../ducks/alerts/reducers';
import analytics from '../ducks/analytics/reducers';
import appSettings from '../ducks/appSettings/reducers';
import assignedAlerts from '../ducks/assignedAlerts/reducers';
import auth from '../ducks/auth/reducers';
import { combineReducers } from 'redux';
import config from '../ducks/config/reducers';
import dashboard from '../ducks/dashboard/reducers';
import downTimeCategories from '../ducks/downTimeCategories/reducers';
import downtimes from '../ducks/downtimes/reducers';
import downtimesPareto from '../ducks/downtimes-pareto/reducers';
import historical from '../ducks/historical/reducers';
import i18n from '../ducks/i18n/reducers';
import layout from '../ducks/layout/reducers';
import machine from '../ducks/machine/reducers';
import machines from '../ducks/machines/reducers';
import mainDashboard from '../ducks/main-dashboard/reducers';
import notifications from '../ducks/notifications/reducers';
import production from '../_clean-code/ducks/production/reducers';
import realtime from '../_clean-code/ducks/realtime/reducers';
import report from '../ducks/report/reducers';
import reports from '../ducks/reports/reducers';
import schedule from '../ducks/schedule/reducers';
import { sessionReducer } from 'redux-react-session';
import shift from '../ducks/shift/reducers';
import simpleWorkOrderNames from '../ducks/simpleWorkOrders/reducers';
import sku from '../ducks/sku/reducer';
import stops from '../ducks/stops/reducers';
import stopsV3 from '../_clean-code/ducks/stops/reducers';
import tags from '../_clean-code/ducks/tags/reducers';
import { reducer as toastrReducer } from 'react-redux-toastr';
import user from '../ducks/user/reducers';
import whatsNew from '../_clean-code/ducks/whatsNew/reducers';
import workOrderNames from '../ducks/workOrders/reducers';

const appReducer = combineReducers({
  auth,
  user,
  notifications,
  i18n,
  toastr: toastrReducer,
  machine,
  machines,
  alerts,
  alertSettings,
  alertSettingsV3,
  assignedAlerts,
  schedule,
  report,
  downtimes,
  downTimeCategories,
  dashboard,
  mainDashboard,
  historical,
  downtimesPareto,
  appSettings,
  shift,
  stops,
  session: sessionReducer,
  tags,
  layout,
  realtime,
  config,
  stopsV3,
  sku,
  production,
  whatsNew,
  reports,
  analytics,
  workOrderNames,
  simpleWorkOrderNames
});

type PreservedState = {
  i18n: ReturnType<typeof i18n>;
  config: ReturnType<typeof config>;
};

const rootReducer = (state, action: { type: string; payload?: any }) => {
  if (!state) return appReducer(state, action);
  if (action.type === 'LOGOUT_SUCCESS') {
    const preservedState: PreservedState = {
      i18n: state?.i18n,
      config: state?.config
    };
    // Reset the whole app state when user logouts
    // @ts-expect-error It's fine to pass an empty key to combine, it will return the initial state
    return appReducer({ ...preservedState }, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
